import baseMessage from './baseMessage'
import { merge, cloneDeep } from 'lodash'
const cloneObj = cloneDeep(baseMessage)
export const ES_PE = {
  message: merge(
    cloneObj,
    {
      label: {
        dni: 'DNI',
        userHint: 'Se puede buscar por Nombres, Apellidos, Documento de identidad'
      },
      selfService: {
        fields: {
          state: 'Provincia',
          city: 'Distrito',
          department: 'Departamento'
        }
      }
    }
  )
}
